import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import StatusChip from "../components/StatusChip";

export default function Workbench() {
    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.listReferrals()
            .then(setCases)
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="workbench-page">
            <div className="mb-10">
                <p className="label-eyebrow mb-3">Referral Workbench</p>
                <h1 className="font-serif text-5xl sm:text-6xl tracking-tight text-ink">
                    Cases automation could not close
                </h1>
                <p className="mt-5 text-lg text-ink-secondary max-w-3xl leading-relaxed">
                    Each row is a referral raised by the digital underwriting platform. Open a case to review the
                    flags, request broker clarification, receive evidence and record a governed decision.
                </p>
            </div>

            <div className="panel" data-testid="workbench-table">
                <div className="grid grid-cols-12 gap-3 px-5 md:px-6 py-3 border-b border-parchment-rule bg-[#F2EFE9]">
                    <div className="col-span-3 label-eyebrow">Submission</div>
                    <div className="col-span-2 label-eyebrow">Broker</div>
                    <div className="col-span-2 label-eyebrow">Sector</div>
                    <div className="col-span-1 label-eyebrow">Limit</div>
                    <div className="col-span-2 label-eyebrow">Status</div>
                    <div className="col-span-2 label-eyebrow text-right">Receipts</div>
                </div>
                {loading ? (
                    <div className="p-6 text-sm text-ink-muted">Loading caseload…</div>
                ) : cases.length === 0 ? (
                    <div className="p-6 text-sm text-ink-muted">No referrals on file.</div>
                ) : (
                    cases.map((c) => (
                        <Link
                            key={c.id}
                            to={`/case/${c.id}`}
                            className="grid grid-cols-12 gap-3 px-5 md:px-6 py-4 border-b border-parchment-rule last:border-b-0 hover:bg-[#F2EFE9] transition-colors"
                            data-testid={`workbench-row-${c.id}`}
                        >
                            <div className="col-span-3">
                                <div className="data-cell text-xs text-ink-muted">{c.submission_ref}</div>
                                <div className="text-base text-ink">{c.insured_label}</div>
                            </div>
                            <div className="col-span-2 self-center text-sm text-ink-secondary">
                                {c.broker_partner}
                            </div>
                            <div className="col-span-2 self-center text-sm">{c.sector}</div>
                            <div className="col-span-1 self-center data-cell text-xs">
                                ${(c.policy_limit_requested_usd / 1_000_000).toFixed(1)}m
                            </div>
                            <div className="col-span-2 self-center">
                                <StatusChip status={c.status} />
                                {c.decision_outcome && (
                                    <div className="mt-1">
                                        <StatusChip status={c.decision_outcome} />
                                    </div>
                                )}
                            </div>
                            <div className="col-span-2 self-center text-right">
                                <span className="data-cell text-xs">
                                    {c.flag_count} flag(s) · {c.receipt_count} receipt(s)
                                </span>
                            </div>
                        </Link>
                    ))
                )}
            </div>
        </div>
    );
}
